import {useQuery} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {User, UserBalance} from '../types/user';

export const getUserBalance = async () => {
  const {data} = await api.get<UserBalance>('/users/balance');
  return data;
};

const USER_BALANCE_REFETCH_INTERVAL = 20 * 1000; //  20 seconds

type Options = {
  refetchInterval?: number;
  staleTime?: number;
  gcTime?: number;
  structuralSharing?: boolean;
};

export const useUserBalanceQuery = (id?: User['id'], options?: Options) => {
  const {refetchInterval, staleTime, gcTime, structuralSharing} = options || {};
  return useQuery({
    queryKey: ['user-balance', id],
    queryFn: () => getUserBalance(),
    enabled: !!id,
    staleTime: staleTime ?? USER_BALANCE_REFETCH_INTERVAL,
    gcTime: gcTime ?? USER_BALANCE_REFETCH_INTERVAL,
    refetchInterval: refetchInterval ?? USER_BALANCE_REFETCH_INTERVAL,
    structuralSharing: structuralSharing ?? false,
  });
};
